import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/PEAK_LOGO.svg'
import _imports_1 from '@/assets/svgs/icons/arrow_down.svg'
import _imports_2 from '@/assets/svgs/icons/sign-out.svg'


const _withScopeId = n => (_pushScopeId("data-v-1003bf5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-container" }
const _hoisted_2 = {
  class: "left-content",
  target: "_blank"
}
const _hoisted_3 = {
  class: "left-content",
  target: "_blank",
  href: "https://peakaccount.com/main.html"
}
const _hoisted_4 = { class: "right-content" }
const _hoisted_5 = { class: "username-container" }
const _hoisted_6 = { class: "username" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "toggle-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-toggle"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "toggle-button"
  })
], -1))
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Sign out"
  }),
  /*#__PURE__*/_createTextVNode("Log out")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _renderSlot(_ctx.$slots, "toggle", {}, undefined, true),
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          style: _normalizeStyle(
            _ctx.getWindowsSize['x'] < 600 || _ctx.getWindowsSize['y'] < 600
              ? 'margin-left: 0px'
              : 'margin-left: 20px'
          ),
          class: "peak-logo",
          src: _imports_0,
          alt: "PEAK LOGO"
        }, null, 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.user?.partnerName) + " ", 1),
          (_ctx.isVat)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(VAT7%)"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut()))
            }, _hoisted_12)
          ])
        ])
      ]),
      _createElementVNode("img", {
        class: "user-profile",
        src: _ctx.userProfile,
        alt: _ctx.userProfileAlt
      }, null, 8, _hoisted_13)
    ])
  ]))
}